// extracted by mini-css-extract-plugin
module.exports = {"sectionLanding":"tutor-module--section-landing--daOqx","tutor":"tutor-module--tutor--3i87X","tutorRight":"tutor-module--tutor-right--32si7"};